import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                {t("site_name")}
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              {t("footer_desc")}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              {t("footer_links")}
            </h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                {t("nav_home")}
              </Link>
              <Link to="/category/hot" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                {t("nav_category")}
              </Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                {t("nav_about")}
              </Link>
              <a href="#download" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                {t("nav_download")}
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              {t("footer_contact")}
            </h4>
            <div className="flex flex-col gap-3 text-sm text-background-50/60">
              <p>邮箱：support@91yingshi.com</p>
              <p>客服微信：91yingshi_kf</p>
              <p>工作时间：每天 9:00 - 21:00</p>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-background-50/10">
          <p className="text-center text-xs text-background-50/40">
            {t("footer_copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
}